import * as stylex from '@stylexjs/stylex';
import { useCanGoBack, type NotFoundRouteProps } from '@tanstack/react-router';

import { Header } from '@/components/header.component';
import { ArrowLeftStrokeIcon, BUTTON_SLOTS, Heading, Text } from '@/libs/serenity-ui';
import { RouterButtonLink } from '@/libs/tanstack-router';

interface NotFoundStateProps extends NotFoundRouteProps {
  withHeader?: boolean;
}

export function NotFoundState({ withHeader, ...props }: NotFoundStateProps) {
  const canGoBack = useCanGoBack();

  return (
    <div {...props} {...stylex.props(notFoundStyles.container)}>
      {withHeader && <Header style={notFoundStyles.navigation} />}
      <div {...stylex.props(notFoundStyles.contentContainer)}>
        <Heading color="placeholder" level={1} size={52}>Page not found</Heading>
        {canGoBack ?
          <RouterButtonLink isRounded size={48} to="..">
            <ArrowLeftStrokeIcon slot={BUTTON_SLOTS.LEFT} />
            <Text>Go back</Text>
          </RouterButtonLink> :
          <RouterButtonLink isRounded size={48} to="/">Home</RouterButtonLink>}
      </div>
    </div>
  );
}

const notFoundStyles = stylex.create({
  container: {
    height: '100%',
    width: '100%',
  },
  navigation: {
    borderBottomStyle: 'none',
    minHeight: null,
    position: 'relative',
  },
  contentContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    justifyContent: 'center',
    paddingTop: 160,
    width: '100%',
  }
});
